import { Package } from "src/models/package";
import { createEntityModel } from "src/store/models/entity/_shared";

export const CompanyPackageEntityModel = createEntityModel<Package>();
